import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Banner from "../img/banner.png";

import { ReactComponent as Star4 } from "../css/svg/star4.svg";
import { ReactComponent as Star5 } from "../css/svg/star5.svg";
import { ReactComponent as Star8 } from "../css/svg/star8.svg";

import authoring_icon from "../img/operationMenu_icons/gestalten.svg";
import effects_icon from "../img/operationMenu_icons/auslosen.svg";
import read_aloud_icon from "../img/operationMenu_icons/vorlesen.svg";
import record_icon from "../img/operationMenu_icons/aufnehmen.svg";
import word_clarification_icon from "../img/operationMenu_icons/sammeln.svg";
import word_wall_icon from "../img/operationMenu_icons/entdecken.svg";

import StarItem from "../components/StarItem.jsx";
import StoriesGallery from "../pages/StoriesGallery";
import { Layout, Button, Menu, Card, Modal } from "antd";
import { unloadUnityWebGL, unityContext } from "../context/unityContext";

import IpadInstallPrompt from "../components/IpadInstallPrompt";


const { Content } = Layout;

const PublicHome = () => {
  const scrollContainerRef = useRef(null); // Reference for the scrollable container


  const [selectedFeature, setSelectedFeature] = useState(null);

  const features = [
    {
      title: "Auslösen",
      icon: effects_icon,
      description:
        "Löse digitale Effekte aus und gestalte die Leseumgebung passend zum Inhalt einer Geschichte.",
      example:
        "Entdecke, wie Klänge, Licht und andere Effekte eine Geschichte begleiten können.",
    },
    {
      title: "Gestalten",
      icon: authoring_icon,
      description:
        "Gestalte eigene Geschichten und werde selbst kreativ.",
      example:
        "Entwickle eigene Ideen, verändere Geschichten und erschaffe neue Leseerlebnisse.",
    },
    {
      title: "Vorlesen",
      icon: read_aloud_icon,
      description:
        "Lies Geschichten laut vor und entdecke, wie Stimme und Sprache Texte lebendig machen.",
      example:
        "Übe das Vorlesen und teile Geschichten mit anderen.",
    },
    {
      title: "Aufnehmen",
      icon: record_icon,
      description:
        "Nimm deine Stimme auf und mache deine eigene Interpretation einer Geschichte hörbar.",
      example:
        "Höre dir deine Aufnahme an und entdecke neue Möglichkeiten, einen Text vorzulesen.",
    },
    {
      title: "Sammeln",
      icon: word_wall_icon,
      description:
        "Sammle Wörter und Ideen und gestalte daraus eine gemeinsame Wortwelt.",
      example:
        "Entdecke interessante Wörter und trage deine eigenen Ideen zusammen.",
    },
    {
      title: "Entdecken",
      icon: word_clarification_icon,
      description:
        "Entdecke die Bedeutung unbekannter Wörter und beschäftige dich genauer mit Texten.",
      example:
        "Erkunde neue Begriffe und erweitere deinen Wortschatz.",
    },
  ];

  useEffect(() => {
    if (unityContext) unloadUnityWebGL();
  }, []);

  const getText = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent;
  };

  // Scroll left
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -300, // Adjust the scroll amount
        behavior: "smooth",
      });
    }
  };

  // Scroll right
  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 300, // Adjust the scroll amount
        behavior: "smooth",
      });
    }
  };

  // #region User Profile Menu
  const handleMenuClick = (e) => {
    if (e.key === "logout") {
      // Handle logout logic here
      console.log("User clicked Menu");
    }
  };

  const onClick = (e) => {
    console.log("click ", e);
  };

  const userProfileMenu = <Menu onClick={handleMenuClick}></Menu>;



  return (
    <div className="dashboard-wrapper">

      <IpadInstallPrompt />

      <Layout className="hero-banner">
        <Content className="banner-content">
          <div className="banner-text">
            <h1>Erwecke deine Geschichten mit{" "} <div className="banner-orange-text"> <span>STREEN Studio</span> </div> {"  "} zum Leben! </h1>
            <p>Mit STREEN Studio kannst du</p>
            <ul className="visually-hidden">
              <li>Spannende Geschichten gemeinsam lesen</li>
              <li>Coole digitale Effekte erstellen</li>
              <li>
                Deine Effekte abspielen, während du deine Geschichten laut
                vorliest
              </li>
            </ul>
          </div>
          <div className="quest-hero">
            {/* CENTRAL IMAGE */}
            <div className="banner-image">
              <img src={Banner} alt="STREEN Studio" />
            </div>
            {/* STARS */}
            <div className="stars-layout">
              <StarItem
                Svg={Star8}
                text="Deine Effekte abspielen, während du deine Geschichten laut vorliest."
                className="star-left"
              />

              <StarItem
                Svg={Star4}
                text="Coole digitale Effekte erstellen."
                className="star-center"
              />

              <StarItem
                Svg={Star5}
                text="Spannende Geschichten gemeinsam lesen."
                className="star-right"
              />
            </div>

          </div>

        </Content>
      </Layout>


      <div className="separator4-container">
        <svg
          className="wave"
          viewBox="0 0 600 20"
          preserveAspectRatio="none"
        >
          <path
            d="M0.292725 6.5C24.2576 -0.833333 48.2226 -0.833333 72.1875 6.5C96.1524 13.8333 120.117 13.8333 144.082 6.5C168.047 -0.833333 192.012 -0.833333 215.977 6.5C239.942 13.8333 263.907 13.8333 287.872 6.5C311.837 -0.833333 335.802 -0.833333 359.766 6.5C383.731 13.8333 407.696 13.8333 431.661 6.5C455.626 -0.833333 479.591 -0.833333 503.556 6.5C527.521 13.8333 551.486 13.8333 575.451 6.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>

        <div className="separator4">
          Entdecken unsere Geschichten
        </div>

        <svg
          className="wave"
          viewBox="0 0 600 20"
          preserveAspectRatio="none"
        >
          <path
            d="M0.292725 6.5C24.2576 -0.833333 48.2226 -0.833333 72.1875 6.5C96.1524 13.8333 120.117 13.8333 144.082 6.5C168.047 -0.833333 192.012 -0.833333 215.977 6.5C239.942 13.8333 263.907 13.8333 287.872 6.5C311.837 -0.833333 335.802 -0.833333 359.766 6.5C383.731 13.8333 407.696 13.8333 431.661 6.5C455.626 -0.833333 479.591 -0.833333 503.556 6.5C527.521 13.8333 551.486 13.8333 575.451 6.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </div>


      <StoriesGallery />

      <div className="separator4-container">
        <svg
          className="wave"
          viewBox="0 0 600 20"
          preserveAspectRatio="none"
        >
          <path
            d="M0.292725 6.5C24.2576 -0.833333 48.2226 -0.833333 72.1875 6.5C96.1524 13.8333 120.117 13.8333 144.082 6.5C168.047 -0.833333 192.012 -0.833333 215.977 6.5C239.942 13.8333 263.907 13.8333 287.872 6.5C311.837 -0.833333 335.802 -0.833333 359.766 6.5C383.731 13.8333 407.696 13.8333 431.661 6.5C455.626 -0.833333 479.591 -0.833333 503.556 6.5C527.521 13.8333 551.486 13.8333 575.451 6.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>

        <div className="separator4">
          Entdecken unsere Tools
        </div>

        <svg
          className="wave"
          viewBox="0 0 600 20"
          preserveAspectRatio="none"
        >
          <path
            d="M0.292725 6.5C24.2576 -0.833333 48.2226 -0.833333 72.1875 6.5C96.1524 13.8333 120.117 13.8333 144.082 6.5C168.047 -0.833333 192.012 -0.833333 215.977 6.5C239.942 13.8333 263.907 13.8333 287.872 6.5C311.837 -0.833333 335.802 -0.833333 359.766 6.5C383.731 13.8333 407.696 13.8333 431.661 6.5C455.626 -0.833333 479.591 -0.833333 503.556 6.5C527.521 13.8333 551.486 13.8333 575.451 6.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          />
        </svg>
      </div>

      <div >

        <div className="operations-menu-demo">
          {features.map((feature) => (
            <button
              key={feature.title}

              className="operation-button-demo"
              onClick={() => setSelectedFeature(feature)}
            >
              <div className="button-content-demo">
                <img src={feature.icon} alt="" />
                <br></br>
                <span>{feature.title}</span>
              </div>
            </button>
          ))}
        </div>

        <Modal
          open={selectedFeature !== null}
          onCancel={() => setSelectedFeature(null)}
          footer={null}
          centered
          destroyOnHidden
          className="feature-info-modal"
          title={
            selectedFeature && (
              <div className="feature-modal-title">
                <img src={selectedFeature.icon} alt="" />
                <span>{selectedFeature.title}</span>
              </div>
            )
          }
        >
          {selectedFeature && (
            <div className="feature-modal-content">
              <p>{selectedFeature.description}</p>

              <div className="feature-modal-example">
                <strong>Was kannst du damit machen?</strong>
                <p>{selectedFeature.example}</p>
              </div>

              <button
                type="button"
                className="feature-modal-close"
                onClick={() => setSelectedFeature(null)}
              >
                Alles klar!
              </button>
            </div>
          )}
        </Modal>

      </div>

    </div>
  );
};

export default PublicHome;
